import bus from '@/bus'
import Vue, { PluginObject, VueConstructor } from 'vue'

declare module 'vue/types/vue' {
    interface Vue {
        $bus: Vue
    }
}

class VueBusPlugin implements PluginObject<any> {

    public install(vue: VueConstructor, options?: any): void {

        vue.prototype.$bus = bus
    }
}

Vue.use(new VueBusPlugin())
